import { Box, Image, Text } from '@chakra-ui/react';

type Props = {
  signedUrl?: string;
  isOwn: boolean;
  maxW?: string;
  maxH?: string;
  mb?: number;
  onOpenLightbox?: () => void;
  onImageLoad?: () => void;
};

export function ImageBubble({
  signedUrl,
  isOwn,
  maxW = '240px',
  maxH = '320px',
  mb = 0,
  onOpenLightbox,
  onImageLoad,
}: Props) {
  return (
    <Box
      borderRadius="12px"
      overflow="hidden"
      maxW={maxW}
      mb={mb}
      cursor="pointer"
      onClick={(e) => {
        e.stopPropagation();
        if (signedUrl) onOpenLightbox?.();
      }}
    >
      {signedUrl ? (
        <Image
          src={signedUrl}
          alt="Chat image"
          maxW={maxW}
          maxH={maxH}
          objectFit="cover"
          display="block"
          borderRadius="12px"
          onLoad={onImageLoad}
        />
      ) : (
        <Box
          w="200px"
          h="150px"
          bg={isOwn ? 'blue.400' : 'gray.200'}
          borderRadius="12px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Text fontSize="xs" color={isOwn ? 'blue.100' : 'gray.500'}>
            Loading…
          </Text>
        </Box>
      )}
    </Box>
  );
}

